import { createSelector } from 'reselect';
import { TabsEntities, TabsState } from './tabs.reducer';

export const getTabsState = (state): TabsState => {
  return state.tabs;
};

export const getTabsEntities = createSelector(
  getTabsState,
  (state: TabsState) => {
    return state.entities;
  }
);

export const getTabs = createSelector(
  getTabsEntities,
  (entities: TabsEntities) => Object.keys(entities)
    .map((threadId) => entities[threadId])
);

export const getCurrentTab = createSelector(
  getTabsEntities,
  getTabsState,
  (entities: TabsEntities, state: TabsState) => {
    return entities[state.currentTabId];
  }
);
